import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  addressInfo: {}
};

export default function addressEdit(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取收货地址详情
    case ACTION_TYPES.GET_ADDRESS_EDIT_DETAIL:
      result.addressInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
